// extracted by mini-css-extract-plugin
export default {"icon-message":"IconMessage_icon-message__wgTnk","icon":"IconMessage_icon__z8UBT","text-content":"IconMessage_text-content__OlP8F","title":"IconMessage_title__ZhFfB"};